import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../apis/store";
import { getDonationTypes } from "../apis/actions/donation.actions";
import { useLocation, useNavigate } from "react-router-dom";
import DonationCard from "../biblio/Cards/DonationCard";
import AddSponsorButton from "../biblio/Buttons/AddSponsorButton";
import { UsergroupAddOutlined } from "@ant-design/icons";

const ConditionalRenderComponents = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [display, setDisplay] = useState<boolean>(false);
  const donationTypes = useSelector(
    (state: RootState) => state?.donation?.donationTypes
  );
  useEffect(() => {
    dispatch(getDonationTypes());
  }, [dispatch]);
  const shareIds = [
    { id: 1, name: "10 ر.س", amount: 10 },
    { id: 2, name: "50 ر.س", amount: 50 },
    { id: 3, name: "100 ر.س", amount: 100 },
  ];
  const handleClick = (body: any) => {
    console.log(body);
  };
  const navigate = useNavigate();
  const hideOnPaths = [
    "/profile",
    "/add-sponsor",
    "/beneficiary/add",
    "/beneficiary/update",
  ];

  const location = useLocation();

  useEffect(() => {
    let check = true;
    hideOnPaths.forEach((el) => {
      if (location.pathname.includes(el)) {
        check = false;
      }
    });
    setDisplay(check);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  return (
    <>
      {display && (
        <>
          <DonationCard
            handleClick={handleClick}
            donationTypes={donationTypes}
            variant="donation"
            requirePhoneNumber
            donationAmounts={0}
            share_ids={shareIds}
            project={null}
          />
          <AddSponsorButton
            onClick={() => navigate("/add-sponsor")}
            icon={<UsergroupAddOutlined />}
            title=" طلب كفالة"
          />
        </>
      )}
    </>
  );
};

export default ConditionalRenderComponents;
